import type * as React from 'react';
import { forwardRef } from 'react';

import styled from 'styled-components';

const TabsHighlight = styled.div`
  position: absolute;
  left: 0px;
  border-radius: 4px;
  transition: 0.15s ease;
  transition-property: width, transform, opacity;
  top: 4px;
  bottom: 4px;
  height: 80%;
`;

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
const SubheaderContainer = forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, className, ...rest }, ref) => (
    <div
      className={`relative flex h-10 w-full flex-row gap-x-1 border-gray-200 border-b border-solid bg-white pl-[23px] ${className}`}
      ref={ref}
      {...rest}
    >
      {children}
    </div>
  )
);

const SubheaderMenu: React.FC<{ children: React.ReactNode }> = ({
  children
}) => (
  <div className="flex max-md:min-w-0 max-md:overflow-x-auto max-md:overflow-y-hidden max-md:[scrollbar-width:none] max-md:[&>*]:shrink-0 max-md:[&::-webkit-scrollbar]:hidden">
    {children}
  </div>
);

export { SubheaderContainer, SubheaderMenu, TabsHighlight };
